<app-header-user></app-header-user>
<section class="account-page mrgn-top greybg py-5">
  <div class="container">
    <div class="">
      <div class="row mt-2 mt-md-0">
        <aside class="col-sm-6 col-md-4 col-lg-3">
          <app-userdashboard-sidebar> </app-userdashboard-sidebar>
        </aside>

        <div class="col-sm-6 col-md-8 col-lg-9 mt-3 mt-md-0 rside-text">
          <app-userheading-section></app-userheading-section>

          <form #addrForm="ngForm" (ngSubmit)="onAddAddressSubmit(addrForm)">
            <div class="profile-content p-3 p-md-4">
              <div class="row">
                <div class="col-md-6 mb-2">
                  <label for="firstName">{{ "editaddress.name" | translate
                    }}<span class="text-danger">*</span></label>
                  <input
                    type="text"
                    name="userName"
                    class="form-control"
                    placeholder="Enter Name"
                    required
                    ngModel
                  />
                </div>

                <div class="col-md-6 mb-2">
                  <label for="email">{{ "editaddress.c_number" | translate
                    }}<span class="text-danger">*</span></label>

                  <span class="country-code">971</span>

                  <input
                    type="text"
                    class="form-control phone-country"
                    name="phoneNumber"
                    maxlength="9"
                    placeholder="50 123 4567"
                    ngModel
                    #phoneNumber="ngModel"
                  />
                </div>
              </div>

              <div class="mb-3">
                <label for="address">
                  {{ "editaddress.adr_1" | translate }}
                  <span class="text-danger">*</span>
                </label>
                <input
                  type="text"
                  name="address_one"
                  class="form-control"
                  placeholder="Type your address"
                  (keydown.enter)="$event.preventDefault()"
                  autocorrect="off"
                  autocapitalize="off"
                  (keyup)="onChanegAddress($event.target.value)"
                  spellcheck="off"
                  #search
                  [(ngModel)]="address_1"
                />
                <p *ngIf="addrerrmsg" style="color: red">{{ addrerrmsg }}</p>
              </div>

              <div class="row">
                <div class="col-md-8 mb-3">
                   <label for="address2">
                      {{ "editaddress.adr_2" | translate
                      }}<span class="text-danger">*</span>
                    </label>
                  <input
                    type="text"
                    class="form-control"
                    name="address_two"
                    placeholder="Address line two"
                    [(ngModel)]="address_2"
                  />
                  <p *ngIf="addr2errmsg" style="color: red">
                    {{ addr2errmsg }}
                  </p>
                </div>

                <div class="col-md-4 mb-3">
                  <label for="address2">{{ "myaccount.villa" | translate
                    }}<span class="text-danger">*</span></label>
                  <input
                    type="text"
                    class="form-control"
                    name="apartment"
                    placeholder="Villa or Appartment"
                    [(ngModel)]="apartment"
                  />
                  <p *ngIf="errmsg" style="color: red">{{ errmsg }}</p>
                </div>
              </div>

              <div class="row">
                <div class="col-md-4 mb-3">
                  <label for="country">{{
                    "myaccount.country" | translate
                    }}</label>
                  <input
                    type="text"
                    name="country"
                    class="form-control"
                    placeholder="Country"
                    [(ngModel)]="country"
                  />
                </div>

                <div class="col-md-4 mb-3">
                  <label for="state">{{ "myaccount.state" | translate }}</label>
                  <input
                    type="text"
                    name="state"
                    class="form-control"
                    placeholder="State"
                    [(ngModel)]="state"
                  />
                </div>
                <div class="col-md-4 mb-3">
                <label for="zip">{{ "myaccount.city" | translate }}</label>
                  <input
                    type="text"
                    name="city"
                    class="form-control"
                    placeholder="city"
                    [(ngModel)]="city"
                  />

                  <input type="hidden" name="lat" [(ngModel)]="latitude" />
                  <input type="hidden" name="long" [(ngModel)]="longitude" />
                </div>

                <div class="col-md-12 mb-3" *ngIf="isMobile">
                  <button
                    (click)="initMap()"
                    class="btn btn-primary detectlocation comm-btn"
                  >
                    Detect my location
                    <span *ngIf="isLoadingdetect">
                      <i class="fas fa-circle-notch fa-spin"></i>
                    </span>
                  </button>
                </div>
              </div>

              <div class="mb-3 default-addtext">
                <input
                  class="mr-1"
                  type="checkbox"
                  value="1"
                  name="isDefault"
                  id="isDefault"
                  ngModel
                />
                <label for="isDefault">{{
                  "editaddress.make_def" | translate
                  }}</label>
              </div>

              <span class="errcls" *ngIf="isError">Error: {{ errmsg }}</span>

              <button
                type="submit"
                class="btn btn-lg btn-block btn-primary comm-btn"
              >
                Add Address
                <!-- <span *ngIf="isLoading">
        <i class="fas fa-circle-notch fa-spin"></i>
    </span> -->
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</section>
